import { useAuth } from "../hooks/useAuth";
import { useTheme } from "../hooks/useTheme";
import { Moon, Sun } from "lucide-react";
import { useState } from "react";

export function Header(): JSX.Element {
  const { status, logout, lockWallets } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (action: () => Promise<void>) => {
    setBusy(true);
    setError(null);
    try { await action(); }
    catch (err) { setError(err instanceof Error ? err.message : "Could not complete action"); }
    finally { setBusy(false); }
  };
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const themeLabel = isDark ? "Switch to light theme" : "Switch to dark theme";
  return (
    <header className="border-b border-border">
      <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-baseline gap-3">
          <h1 className="font-serif text-[28px] leading-none tracking-brand">VALET</h1>
          <span className="text-[11px] uppercase tracking-brand text-muted">counter-trading</span>
        </div>
        {status?.authenticated ? (
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={toggleTheme}
              className="btn btn-ghost h-9 w-9 justify-center p-0"
              aria-label={themeLabel}
              title={themeLabel}
            >
              {isDark ? <Sun size={15} strokeWidth={1.5} /> : <Moon size={15} strokeWidth={1.5} />}
            </button>
            <button disabled={busy} onClick={() => void run(lockWallets)} className="btn btn-ghost">
              Stop tasks &amp; lock wallets
            </button>
            <button disabled={busy} onClick={() => void run(logout)} className="btn btn-primary">
              Logout
            </button>
          </div>
        ) : (
          <div />
        )}
      </div>
      {error && <p role="alert" className="text-red-500 text-sm px-8 pb-3">{error}</p>}
    </header>
  );
}
